import { DesignSystem } from '@workbuddy/ui/v2/design-system';

const tokens = DesignSystem.tokens;

export const outlineSetCrewDialogStyleId = 'service-plan-outline-set-crew-dialog-theme';

/**
 * Title and sentence only. The two crew controls are Surface Engine fields now, so `wb-field` and
 * the Form host own every token the dialog used to bridge for them — the label track, the control
 * border and background, the field gap, and the footer. Bridging them here as well would be a
 * second, quieter definition of the same chrome.
 */
export const outlineSetCrewDialogBridgeStyles = {
  'service-plan-outline-set-crew-dialog': {
    '--local-set-crew-bg': tokens.color.background.primary,
    '--local-set-crew-title': tokens.color.text.primary,
    '--local-set-crew-body': tokens.color.text.secondary,
    '--local-set-crew-gap': tokens.spacing.lg,
    '--local-set-crew-pad': tokens.spacing.xl,
    '--local-set-crew-title-size': tokens.font.size.textLg,
    '--local-set-crew-body-size': tokens.font.size.textSm,
    '--local-set-crew-title-weight': tokens.font.weight.semibold,
    '--local-set-crew-line-title': tokens.lineHeight.textLg,
    '--local-set-crew-line-body': tokens.lineHeight.textSm,
    '--local-set-crew-font': tokens.font.family.body,
  },
};
